<template>
  <section v-if="results" :class="`section resources-carousel ${sestionClass} ${bgColor}`">
    <div class="container mx-auto px-4">
      <div class="section-title__wrapper">
        <h3 class="section-title">{{ title}}</h3>
      </div>
      <div class="resources__cards">
        <Carsousel type="Resource" :payload="results" :settings="settings"></Carsousel>
      </div>
    </div>
  </section>
</template>

<script>
import algoliasearch from 'algoliasearch';
import Carsousel from '../carousel-layouts/Carousel.vue';

export default {
  components: {
    Carsousel
  },

  props: {
    id: {
      type: String
    },
    resource_type: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    bgColor: {
      type: String,
      default: 'bg-grey'
    }
  },

  created() {
    this.client = algoliasearch(this.$config.algolia.app_id, this.$config.algolia.app_key);
    this.index = this.client.initIndex(this.index_name);

    this.index
      .search('', this.searchObject)
      .then((results) => {
        // console.log("Resource search raw results:", results);
        if (results.nbHits > 0) {
          this.filteredResults = results.hits.filter((el) => {
            return el['id'] !== this.id && el['resource-type'].toLowerCase() === this.resource_type.toLowerCase();
          });
          this.results = this.filteredResults.length ?  this.filteredResults : false;
        } else {
          this.results = false;
        }
      });
  },
  
  data() {
    return {
      client: false,
      index: false,
      index_name: (this.$config.test_env) ? 'resources-dev' : 'resources-live',
      searchObject: {
        hitsPerPage: 20,
        facets: ['resource-type'],
        facetFilters: [[`resource-type:${this.resource_type}`]]
      },
      results: false,
    }
  },

  computed: {
    sestionClass() {
      let result = this.resource_type ? this.resource_type.replace(/\s+/g, '-').toLowerCase() : '';
      return result;
    },
    settings() {
      return {
        width: '100%',
        gap: '1rem',
        pagination: false,
        arrows: false,
        perPage: 5,
        breakpoints: {
          480: {
            perPage: 1,
            drag: this.results.length >= 1
          },
          768: {
            perPage: 2,
            drag: this.results.length >= 2
          },
          1024: {
            perPage: 3,
            drag: this.results.length >= 3
          },
          1280: {
            perPage: 4,
            drag: this.results.length >= 4
          },
          1536: {
            perPage: 5,
            drag: this.results.length >= 5
          },
        }
      }
    }
  }
}
</script>
